const _ = require('lodash');
const { Module, SurveyType, DataSourceType, LicenseInterval } = require('../services/prisma/types');

const ID = 'ID';
const TEXT = 'TEXT';
const NUMBER = 'NUMBER';
const BOOLEAN = 'BOOLEAN';
const ID_ARRAY = 'ID_ARRAY';
const SURVEY_GROUP_ID = 'SURVEY_GROUP_ID';
const ARRAY = 'ARRAY';
const PRICE = 'PRICE';
const OBJ = 'OBJ';

const SETTING_TYPES = {
  ID,
  TEXT,
  NUMBER,
  BOOLEAN,
  ID_ARRAY,
  SURVEY_GROUP_ID,
  ARRAY,
  PRICE,
  OBJ,
};

const SETTING_TYPES_COLUMN_WIDTH = {
  ID: 250,
  TEXT: 400,
  NUMBER: 100,
  BOOLEAN: 100,
  ID_ARRAY: 250,
  SURVEY_GROUP_ID: 200,
  ARRAY: 200,
  PRICE: 400,
};

const ALL_SETTINGS = {
  surveyLimit: {
    type: NUMBER,
  },
  generalSurveyLimit: {
    type: NUMBER,
  },
  feedbackLimit: {
    type: NUMBER,
  },
  targetedSurveyLimit: {
    type: NUMBER,
  },
  cxSurveyLimit: {
    type: NUMBER,
  },
  customTheme: {
    type: BOOLEAN,
  },
  userSegmentLimit: {
    type: NUMBER,
  },
  sharedSegmentLimit: {
    type: NUMBER,
  },
  matomoSegmentLimit: {
    type: NUMBER,
  },
  funnelLimit: {
    type: NUMBER,
  },
  tagComments: {
    type: BOOLEAN,
  },
  userLimit: {
    type: NUMBER,
  },
  advancedUserLimit: {
    type: NUMBER,
  },
  responseLimit: {
    type: NUMBER,
  },
  yearlyResponseLimit: {
    type: NUMBER,
  },
  heatmapLimit: {
    type: NUMBER,
  },
  heatmapSampleLimit: {
    type: NUMBER,
  },
  sessionRecordingLimit: {
    type: NUMBER,
  },
  sessionRecordingSampleLimit: {
    type: NUMBER,
  },
  surveyVersionLimit: {
    type: NUMBER,
  },
  surveyLanguageLimit: {
    type: NUMBER,
  },
  matomoMonthlyVisitLimit: {
    type: NUMBER,
  },
  dedicatedAnalyst: {
    type: BOOLEAN,
  },
  unlimitedHeatmaps: {
    type: BOOLEAN,
  },
  reportLimit: {
    type: NUMBER,
  },
  customCookiePrefix: {
    type: BOOLEAN,
  },
  disableCookies: {
    type: BOOLEAN,
  },
  yearlyPrices: {
    type: ARRAY,
    private: true,
    settings: ['matomoMonthlyVisitLimit', 'analytics', 'unlimitedHeatmaps', 'dedicatedAnalyst'],
  },
  monthlyPrices: {
    type: ARRAY,
    private: true,
    settings: ['matomoMonthlyVisitLimit', 'analytics', 'unlimitedHeatmaps', 'dedicatedAnalyst'],
  },
  yearlyPrice: {
    type: PRICE,
  },
  monthlyPrice: {
    type: PRICE,
  },
  hubspotProductId: {
    private: true,
  },
  hubspotTrialProductId: {
    private: true,
  },
  hubspotUnlimitedHeatmapsProductId: {
    private: true,
  },
  hubspotDedicatedAnalystProductId: {
    private: true,
  },
  actionLimit: {
    type: NUMBER,
  },
  dailyHeatmapSampleLimit: {
    type: NUMBER,
  },
  dailySessionRecordingLimit: {
    type: NUMBER,
  },
  visitLimit: {
    type: NUMBER,
  },
  crashAnalytics: {
    type: BOOLEAN,
  },
  formAnalytics: {
    type: BOOLEAN,
  },
  mediaAnalytics: {
    type: BOOLEAN,
  },
  eCommerceAnalytics: {
    type: BOOLEAN,
  },
  multiAttribution: {
    type: BOOLEAN,
  },
  dataRetentionMonths: {
    type: NUMBER,
  },
  seoWebVitals: {
    type: BOOLEAN,
  },
  goalLimit: {
    type: NUMBER,
  },
  heatmapsDataRetentionDays: {
    type: NUMBER,
  },
  monthlyBrokenlinksCheckLimit: {
    type: NUMBER,
  },
  brokenLinksWeeklyCheck: {
    type: BOOLEAN,
  },
  brokenLinksMonthlyCheck: {
    type: BOOLEAN,
  },
  advancedCampaignParameters: {
    type: BOOLEAN,
  },
  expertCampaignParameters: {
    type: BOOLEAN,
  },
  monthlySinglePrice: {
    type: PRICE,
  },
  monthlyMultiplePrice: {
    type: PRICE,
  },
  templateCustomerId: {
    type: ID,
  },
  feedbackTemplatesWebsiteId: {
    type: ID,
  },
  targetedSurveyTemplatesWebsiteId: {
    type: ID,
  },
  globalBenchmarkCategoryId: {
    type: ID,
  },
  customerOwnerRoleId: {
    type: ID,
  },
  customerAdvancedUserRoleId: {
    type: ID,
  },
  dataSourceOwnerRoleId: {
    type: ID,
  },
  dataSourceAdvancedUserRoleId: {
    type: ID,
  },
  nextOrderNumber: {
    type: NUMBER,
  },
  domain: {},
  blockedDomains: {
    type: ARRAY,
    settings: ['domain'],
  },
  blockedEmailDomains: {
    type: ARRAY,
    settings: ['domain'],
  },
  demoUserEmail: {},
  demoUserPassword: {},
  demoData: {
    type: OBJ,
  },
  demoTargetDataSourceId: {
    type: ID,
  },
  demoTargetSurveyIds: {
    type: ID_ARRAY,
  },
  demoShowDataSource: {
    type: BOOLEAN,
  },
  heatmapsDaysBeforeEmptyAlert: {
    type: NUMBER,
  },
  heatmapsMinSamplesBeforeDataAlert: {
    type: NUMBER,
  },
  heatmapsEmptyAlertFormGuid: {
    type: TEXT,
  },
  heatmapsDataAlertFormGuid: {
    type: TEXT,
  },
  sessionRecordingsDaysBeforeEmptyAlert: {
    type: NUMBER,
  },
  sessionRecordingsMinSamplesBeforeDataAlert: {
    type: NUMBER,
  },
  sessionRecordingsEmptyAlertFormGuid: {
    type: TEXT,
  },
  sessionRecordingsDataAlertFormGuid: {
    type: TEXT,
  },
  actionLimitReachedFormGuid: {
    type: TEXT,
  },
  actionLimitEstimatedFormGuid: {
    type: TEXT,
  },
  responseLimitReachedFormGuid: {
    type: TEXT,
  },
  responseLimitEstimatedFormGuid: {
    type: TEXT,
  },
  selectedCustomer: {
    type: ID,
  },
  generalSurveyTemplate: {
    type: SURVEY_GROUP_ID,
    globalSetting: 'templateCustomerId',
  },
  feedbackTemplate: {
    type: SURVEY_GROUP_ID,
    globalSetting: 'templateCustomerId',
  },
  targetedSurveyTemplate: {
    type: SURVEY_GROUP_ID,
    globalSetting: 'templateCustomerId',
  },
};

const LICENSE_SETTINGS = _.pick(ALL_SETTINGS, [
  'surveyLimit',
  'generalSurveyLimit',
  'feedbackLimit',
  'targetedSurveyLimit',
  'cxSurveyLimit',
  'customTheme',
  'userSegmentLimit',
  'sharedSegmentLimit',
  'matomoSegmentLimit',
  'funnelLimit',
  'tagComments',
  'userLimit',
  'advancedUserLimit',
  'responseLimit',
  'yearlyResponseLimit',
  'heatmapLimit',
  'heatmapSampleLimit',
  'sessionRecordingLimit',
  'sessionRecordingSampleLimit',
  'surveyVersionLimit',
  'surveyLanguageLimit',
  'matomoMonthlyVisitLimit',
  'dedicatedAnalyst',
  'unlimitedHeatmaps',
  'reportLimit',
  'customCookiePrefix',
  'disableCookies',
  'yearlyPrices',
  'monthlyPrices',
  'yearlyPrice',
  'monthlyPrice',
  'hubspotProductId',
  'hubspotTrialProductId',
  'hubspotUnlimitedHeatmapsProductId',
  'hubspotDedicatedAnalystProductId',
  'actionLimit',
  'dailyHeatmapSampleLimit',
  'dailySessionRecordingLimit',
  'visitLimit',
  'crashAnalytics',
  'formAnalytics',
  'mediaAnalytics',
  'eCommerceAnalytics',
  'multiAttribution',
  'dataRetentionMonths',
  'seoWebVitals',
  'goalLimit',
  'heatmapsDataRetentionDays',
  'monthlyBrokenlinksCheckLimit',
  'brokenLinksWeeklyCheck',
  'brokenLinksMonthlyCheck',
  'advancedCampaignParameters',
  'expertCampaignParameters',
]);

const ANALYTICS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'disableCookies',
    'customCookiePrefix',
    'dataRetentionMonths',
    'hubspotProductId',
    'hubspotTrialProductId',
    'crashAnalytics',
    'formAnalytics',
    'mediaAnalytics',
    'eCommerceAnalytics',
    'multiAttribution',
    'seoWebVitals',
    'goalLimit',
    'monthlyBrokenlinksCheckLimit',
    'brokenLinksWeeklyCheck',
    'brokenLinksMonthlyCheck',
    'advancedCampaignParameters',
    'expertCampaignParameters',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['visitLimit', 'actionLimit', 'monthlyPrice'],
  },
};

const HEATMAPS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'heatmapsDataRetentionDays',
    'hubspotProductId',
    'hubspotTrialProductId',
    'heatmapLimit',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['visitLimit', 'dailyHeatmapSampleLimit', 'dailySessionRecordingLimit', 'monthlyPrice'],
  },
};

const UX_SURVEYS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'hubspotProductId',
    'hubspotTrialProductId',
    'surveyLimit',
    'generalSurveyLimit',
    'feedbackLimit',
    'targetedSurveyLimit',
    'customTheme',
    'userSegmentLimit',
    'surveyVersionLimit',
    'surveyLanguageLimit',
    'tagComments',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['responseLimit', 'visitLimit', 'monthlyPrice'],
  },
};

const CX_SURVEYS_SETTINGS = {
  ..._.pick(LICENSE_SETTINGS, [
    'userLimit',
    'advancedUserLimit',
    'reportLimit',
    'hubspotProductId',
    'hubspotTrialProductId',
    'cxSurveyLimit',
    'customTheme',
    'userSegmentLimit',
    'surveyVersionLimit',
    'surveyLanguageLimit',
    'tagComments',
  ]),
  prices: {
    type: ARRAY,
    private: true,
    settings: ['yearlyResponseLimit', 'yearlyPrice'],
  },
};

const ADDON_SETTINGS = _.pick(ALL_SETTINGS, [
  'monthlySinglePrice',
  'monthlyMultiplePrice',
]);

const MODULE_LICENSE_SETTINGS = {
  [Module.Analytics]: ANALYTICS_SETTINGS,
  [Module.Heatmaps]: HEATMAPS_SETTINGS,
  [Module.UxSurveys]: UX_SURVEYS_SETTINGS,
  [Module.CxSurveys]: CX_SURVEYS_SETTINGS,
  [Module.Addon]: ADDON_SETTINGS,
};

const MODULE_LIMIT_SETTING = {
  [Module.Analytics]: 'actionLimit',
  [Module.Heatmaps]: 'dailyHeatmapSampleLimit',
  [Module.UxSurveys]: 'visitLimit',
  [Module.CxSurveys]: 'yearlyResponseLimit',
};

const MODULE_FREE_LIMIT_SETTING = {
  [Module.Analytics]: 'actionLimit',
  [Module.Heatmaps]: 'dailyHeatmapSampleLimit',
  [Module.UxSurveys]: 'responseLimit',
  [Module.CxSurveys]: 'yearlyResponseLimit',
};

const PERIOD_INTERVAL = {
  [DataSourceType.Website]: LicenseInterval.Monthly,
  [DataSourceType.Cx]: LicenseInterval.Yearly,
};

const MODULE_LABEL = {
  [Module.Analytics]: 'Analytics',
  [Module.Heatmaps]: 'Heatmaps & recordings',
  [Module.UxSurveys]: 'UX-surveys',
  [Module.CxSurveys]: 'CX-surveys',
  [Module.Addon]: 'Addon',
};

const MODULE_LIMIT_SETTING_LABEL = {
  actionLimit: 'Actions/month',
  visitLimit: 'Visits/month',
  responseLimit: 'Responses/month',
  yearlyResponseLimit: 'Responses/year',
  dailyHeatmapSampleLimit: 'Heatmap samples/day',
  dailySessionRecordingLimit: 'Recorded sessions/day',
};

const SURVEY_TYPE_LIMITS = {
  [SurveyType.General]: 'generalSurveyLimit',
  [SurveyType.Feedback]: 'feedbackLimit',
  [SurveyType.Targeted]: 'targetedSurveyLimit',
  [SurveyType.Cx]: 'cxSurveyLimit',
};

const SURVEY_LIMIT_TYPES = {
  generalSurveyLimit: SurveyType.General,
  feedbackLimit: SurveyType.Feedback,
  targetedSurveyLimit: SurveyType.Targeted,
  cxSurveyLimit: SurveyType.Cx,
};

const GLOBAL_SETTINGS = _.pick(ALL_SETTINGS, [
  'templateCustomerId',
  'feedbackTemplatesWebsiteId',
  'targetedSurveyTemplatesWebsiteId',
  'globalBenchmarkCategoryId',
  'customerOwnerRoleId',
  'customerAdvancedUserRoleId',
  'dataSourceOwnerRoleId',
  'dataSourceAdvancedUserRoleId',
  'nextOrderNumber',
  'blockedDomains',
  'blockedEmailDomains',
  'demoUserEmail',
  'demoUserPassword',
  'demoData',
  'demoTargetDataSourceId',
  'demoTargetSurveyIds',
  'demoShowDataSource',
]);

const HUBSPOT_SETTINGS = _.pick(ALL_SETTINGS, [
  'heatmapsDaysBeforeEmptyAlert',
  'heatmapsMinSamplesBeforeDataAlert',
  'heatmapsEmptyAlertFormGuid',
  'heatmapsDataAlertFormGuid',
  'sessionRecordingsDaysBeforeEmptyAlert',
  'sessionRecordingsMinSamplesBeforeDataAlert',
  'sessionRecordingsEmptyAlertFormGuid',
  'sessionRecordingsDataAlertFormGuid',
  'actionLimitReachedFormGuid',
  'actionLimitEstimatedFormGuid',
  'responseLimitReachedFormGuid',
  'responseLimitEstimatedFormGuid',
]);

const USER_GLOBAL_SETTINGS = _.pick(ALL_SETTINGS, [
  'selectedCustomer',
]);

const SURVEY_TEMPLATE_SETTINGS = _.pick(ALL_SETTINGS, [
  'generalSurveyTemplate',
  'feedbackTemplate',
  'targetedSurveyTemplate',
]);

const SURVEY_TYPE_TEMPLATES_SETTINGS = {
  [SurveyType.General]: 'generalSurveyTemplate',
  [SurveyType.Feedback]: 'feedbackTemplate',
  [SurveyType.Targeted]: 'targetedSurveyTemplate',
};

const MODULE_LEVELS = {
  1: 'Free',
  2: 'Insights',
  3: 'Insights Pro',
  Free: 1,
  Insights: 2,
  'Insights Pro': 3,
};

module.exports = {
  SETTING_TYPES,
  SETTING_TYPES_COLUMN_WIDTH,
  LICENSE_SETTINGS,
  PERIOD_INTERVAL,
  MODULE_LICENSE_SETTINGS,
  MODULE_LIMIT_SETTING,
  MODULE_FREE_LIMIT_SETTING,
  MODULE_LABEL,
  MODULE_LEVELS,
  MODULE_LIMIT_SETTING_LABEL,
  SURVEY_TYPE_LIMITS,
  SURVEY_LIMIT_TYPES,
  GLOBAL_SETTINGS,
  HUBSPOT_SETTINGS,
  USER_GLOBAL_SETTINGS,
  SURVEY_TEMPLATE_SETTINGS,
  SURVEY_TYPE_TEMPLATES_SETTINGS,
  ALL_SETTINGS,
};
